"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvcBillingAutomationError = void 0;
class SvcBillingAutomationError extends Error {
    constructor(message, previous) {
        super(message);
        this.previous = previous;
    }
}
exports.SvcBillingAutomationError = SvcBillingAutomationError;
//# sourceMappingURL=SvcBillingAutomationError.js.map